export default {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 8,
    marginTop: 8,
  },
  inputStyle: {
    borderRadius: 8,
    borderWidth: 0,
  },
  inputNumber: {
    borderRadius: 8,
    borderWidth: 0,
    padding: 1,
  },
};
